import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import i18n from '@opsbase/lib-i18n';
import DataTreeController from '@opsbase/web-ctrl-datatree/DataTreeController';
import DVLTable from '@opsbase/web-dvl-table';
import DVLToolbar from '@opsbase/web-dvl-toolbar';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
export function OpViewConversations(props) {
    var _a, _b;
    const { op } = props;
    return (React.createElement(Horizontal, { gutter: true, style: {
            backgroundColor: Palette.WhiteSmoke.main,
            border: `1px solid ${Palette.BorderGrey.main}`,
            height: '100%',
        } },
        !((_a = op.conversations) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(Vertical, { padding: true, centered: true, style: { paddingTop: 32 } },
            React.createElement(Text, { variant: "h1" }, i18n.t('op-no-notes')),
            React.createElement("img", { src: "/assets/images/Issues-state.png", width: 300 }))),
        ((_b = op.conversations) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(DataTreeController, { viewId: 'allconversations', baseFilter: {
                queryFieldKey: QueryFieldKey.CONVERSATION_OP,
                id: op.id,
            } },
            React.createElement(Vertical, { gutter: true, padding: true, style: { overflow: 'hidden' } },
                React.createElement(Pane, null,
                    React.createElement(DVLToolbar, { disableCharts: true, disableSaving: true })),
                React.createElement(DVLTable, { itemPage: Pages.CONVERSATION_DETAILS }))))));
}
export default OpViewConversations;
